import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5h4","key":"svg-0"}],["path",{"d":"M17 5h4","key":"svg-1"}],["path",{"d":"M3 19h18","key":"svg-2"}],["path",{"d":"M4 9l2 6h1l2 -6","key":"svg-3"}],["path",{"d":"M12 10v5","key":"svg-4"}],["path",{"d":"M16 15v-6h2a2 2 0 1 1 0 4h-2","key":"svg-5"}],["path",{"d":"M10 5a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2","key":"svg-6"}]]

const IconVip2 = createReactComponent('outline', 'vip-2', 'Vip2', __iconNode);

export default IconVip2;